module.exports = __webpack_public_path__ + "img/Clear_Popup_Icon.316c5636.svg";